import { Box, TextField, Typography } from "@mui/material";
import { makeSxStyles } from "ui";

import CustomerNote from "./customer-note";
import { useParams } from "react-router-dom";
import { SendOutlined } from "@mui/icons-material";
import { useLocationNotes } from "../../../hooks/use-location-notes";
import { fieldLabelSx } from "@/shared/components/crm/form-typography";

const CustomerNotesContainer = () => {
  const { addressId } = useParams<{
    addressId?: string;
  }>();
  const styles = useStyles();

  const {
    data,
    values,
    handleBlur,
    handleChange,
    touched,
    errors,
    submitForm,
    handleDeleteNote,
    handleEditNote,
  } = useLocationNotes({
    locationId: addressId || "",
    enabled: !!addressId,
  });

  return (
    <Box sx={styles.customerNotesContainer}>
      <Typography sx={fieldLabelSx}>Customer Notes</Typography>
      <Box sx={styles.customerNotesList}>
        {data?.data?.map((customerNote) => (
          <CustomerNote
            key={customerNote.id}
            note={customerNote}
            onDelete={() => handleDeleteNote(customerNote.id)}
            onBellClick={() =>
              handleEditNote(customerNote.id, {
                mustRead: customerNote.mustRead ? false : true,
              })
            }
            onContentEdit={(newContent) =>
              handleEditNote(customerNote.id, {
                content: newContent,
              })
            }
          />
        ))}
      </Box>
      <Typography sx={fieldLabelSx}>Add Note</Typography>
      <TextField
        placeholder="Add Note"
        name="content"
        id="content"
        type="text"
        value={values.content}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={touched.content && errors.content}
        error={touched.content && !!errors.content}
        margin="dense"
        variant="outlined"
        fullWidth
        multiline
        rows={5}
        InputProps={{
          endAdornment: (
            <SendOutlined sx={styles.sendIcon} onClick={submitForm} />
          ),
        }}
        sx={styles.textField}
      />
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  customerNotesContainer: {
    mt: "40px",
    display: "grid",
    // Match FieldRow (label 260 / gap 24 / input 360) so Notes align with the
    // Customer Info / Address Info sections above.
    gridTemplateColumns: "260px 360px",
    columnGap: "24px",
    rowGap: "16px",
  },
  customerNotesList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  textField: {
    "& svg": {
      alignSelf: "flex-end",
    },
  },
  sendIcon: {
    cursor: "pointer",
  },
}));

export default CustomerNotesContainer;
